import { takeLatest, put, call } from 'redux-saga/effects';
import { HTTP_HEADERS, HTTP_RESPONSE_TYPE_ARRAYBUFFER } from '../../../constants';
import request from '../../../components/Utils/httpHelper';
import { API_CASES_EXTRACT_DOWNLOAD, apiCasesExtractDownloadResponse} from './action';
import { CORE_API } from '../../../config';

export function* apiCasesExtractDownloadRequest(action){
    let requestURL = `${CORE_API}/apidata/extract`;

    try {
        const data = yield call(request, requestURL, { method: 'POST', data: action.data, headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        if(data && data.status == "200" ){
            yield put(apiCasesExtractDownloadResponse({ data : data.data , status : "SUCCESS"}));
        }else{
            yield put(apiCasesExtractDownloadResponse({ data : data.data , status :  "FAILURE"}));
        }
    }
    catch (err) {
        yield put(apiCasesExtractDownloadResponse( { ... err.response , status : "FAILURE"}))
    }
}
 
export function* apiCasesExtractDownload() {
    yield takeLatest(API_CASES_EXTRACT_DOWNLOAD, apiCasesExtractDownloadRequest);
}